<div class="content">
  <h3>{{'t.how-install' | translate}}</h3>
  <app-slider class="slider" #pwaSlider [intersectionObserver]="false" [slideList]="installSteps" [config]="sliderConfig">
    @for (item of pwaSlider?.slideList(); track item) {
      <div class="slider__slide keen-slider__slide">
        <div class="content__img">
          <img [src]="item" alt="">
        </div>
      </div>
    }
  </app-slider>
  @if (pwaSlider) {
    <ng-container *ngTemplateOutlet="pwaSlider?.paginationElement()"></ng-container>
  }
</div>
